import {ValueObject} from '@s-ui/domain'

export class AdDataValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.id
   * @param {String} data.make
   * @param {String} data.model
   * @param {String} data.photo
   * @param {Number} data.price
   * @param {String} data.sellerName
   */
}
